export * from './points-expiration.styled.default';
